import { fmtDate } from "@/lib/format";
import { COMPANY } from "@/lib/company";
import { createDoc, money, NAVY, GOLD, TEXT, SLATE, LINE, WHITE } from "@/lib/docPdf";

const METHOD = { nakit: "Nakit", havale: "Havale / EFT", kredi_karti: "Kredi Kartı", cek: "Çek" };
const ONES = ["", "bir", "iki", "üç", "dört", "beş", "altı", "yedi", "sekiz", "dokuz"];
const TENS = ["", "on", "yirmi", "otuz", "kırk", "elli", "altmış", "yetmiş", "seksen", "doksan"];
const SCALES = ["", "bin", "milyon", "milyar", "trilyon"];
const tri = (n) => { const h = Math.floor(n / 100), t = Math.floor((n % 100) / 10), o = n % 10; return `${h ? `${h > 1 ? ONES[h] : ""}yüz` : ""}${TENS[t]}${ONES[o]}`; };

// Tutarın yazıyla gösterimi (makbuz standardı): 1.250,50 → "#BİNİKİYÜZELLİ TÜRK LİRASI ELLİ KURUŞ#"
export const amountInWords = (v) => {
  const cents = Math.round(Math.abs(Number(v || 0)) * 100);
  let lira = Math.floor(cents / 100);
  const kr = cents % 100;
  let words = lira ? "" : "sıfır";
  for (let i = 0; lira > 0; i += 1) {
    const g = lira % 1000;
    if (g) words = `${i === 1 && g === 1 ? "" : tri(g)}${SCALES[i]}${words}`;
    lira = Math.floor(lira / 1000);
  }
  const up = (s) => s.toLocaleUpperCase("tr");
  return `#${up(words)} TÜRK LİRASI${kr ? ` ${up(tri(kr))} KURUŞ` : ""}#`;
};

/** Tahsilat Makbuzu PDF — sade: taraf kartı (sağda makbuz bilgileri), tutar satırı + yazıyla, açıklama, imzalar. */
export async function buildCollectionReceiptPdf(r) {
  const D = await createDoc({ title: "TAHSİLAT MAKBUZU", contLine: `Makbuz #${r.receipt_no || ""}` });
  const { pdf, F, T, fill, stroke, shrink, ellipsize, pageW, M, W, HEAD1 } = D;
  D.header(1);
  const inv = r.invoice_no ? `#${r.invoice_no}` : r.invoice_id ? "Taslak fatura" : "";
  const method = METHOD[r.method] || r.method || "—";
  const meta = [["MAKBUZ NO", `#${r.receipt_no || "—"}`], ["TARİH", fmtDate(r.date)], ["ÖDEME YÖNTEMİ", method]];
  if (inv) meta.push(["İLGİLİ FATURA", inv]);
  let y = HEAD1 + 5;
  y += D.partyCard(y, {
    name: r.contact_title || r.received_from || "—",
    lines: [r.received_from && r.contact_title ? `Ödemeyi yapan: ${r.received_from}` : ""],
    meta,
  }) + 6;

  // Tahsil edilen tutar — tek ince çerçeve
  T(F.body, "normal", 7.6, TEXT);
  const wl = pdf.splitTextToSize(`Yalnız: ${amountInWords(r.amount)}`, W - 12).slice(0, 2);
  const ph = 15 + wl.length * 3.9;
  stroke(LINE, 0.4); fill(WHITE); pdf.roundedRect(M, y, W, ph, 2, 2, "FD");
  fill(GOLD); pdf.rect(M, y + 3, 1.1, ph - 6, "F");
  T(F.body, "bold", 6, SLATE); pdf.text("TAHSİL EDİLEN TUTAR", M + 5, y + 6, { charSpace: 0.6 });
  const amt = money(r.amount);
  const afs = shrink(amt, W - 80, F.head, "bold", 18, 11);
  T(F.head, "bold", afs, NAVY); pdf.text(amt, pageW - M - 5, y + 9.2, { align: "right" });
  T(F.body, "normal", 7.6, TEXT); pdf.text(wl, M + 5, y + 13.2, { lineHeightFactor: 1.3 });
  y += ph + 6;

  if (r.description) {
    T(F.body, "bold", 6, SLATE); pdf.text("AÇIKLAMA", M, y + 2, { charSpace: 0.6 });
    T(F.body, "normal", 8, TEXT);
    const dl = pdf.splitTextToSize(String(r.description), W).slice(0, 6);
    pdf.text(dl, M, y + 6.6, { lineHeightFactor: 1.35 });
    y += 6.6 + dl.length * 3.9 + 4;
  }

  const legal = `Yukarıda belirtilen tutar ${COMPANY.name} tarafından eksiksiz tahsil edilmiştir${inv ? ` (İlgili fatura: ${inv})` : " ve cari hesaba mahsuben işlenmiştir"}. İşbu makbuz iki nüsha olarak düzenlenmiştir.`;
  T(F.body, "normal", 7.8, TEXT);
  const ll = pdf.splitTextToSize(legal, W);
  pdf.text(ll, M, y + 3, { lineHeightFactor: 1.45 });
  y += ll.length * 4 + 8;

  const sigW = 74;
  [[M, "ÖDEMEYİ YAPAN", r.received_from || r.contact_title || ""], [pageW - M - sigW, "TAHSİL EDEN · İMZA / KAŞE", `${COMPANY.name}${r.created_by ? ` · ${r.created_by}` : ""}`]].forEach(([x, label, sub]) => {
    stroke(NAVY, 0.4); pdf.line(x, y + 14, x + sigW, y + 14);
    T(F.body, "bold", 6.8, NAVY); pdf.text(label, x, y + 18.2, { charSpace: 0.4 });
    T(F.body, "normal", 6.6, SLATE); pdf.text(ellipsize(sub, sigW), x, y + 22);
  });
  return D.finish();
}
